import { useCallback, useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { IAttempt } from "@miplatform/types";
import { buildActivityDateFilter } from "@miplatform/utils";
import { ActivityDateRange } from "@mibuildweb/components";

export const useWorkOrderAttemptDrawerActivityViewModel = ({
  attempt,
  stateManager,
}: {
  attempt: IAttempt | null;
  stateManager: any;
}) => {
  const [attemptActivities, setAttemptActivities] = useState<any[]>([]);

  const getAttemptActivities = useCallback(
    (dateRange?: ActivityDateRange) => {
      stateManager.run(async () => {
        const response = await taskService.activities.getAll({
          params: {
            refId: `task-service/work-orders/${attempt?.workOrderId}/assignments/${attempt?.assignment?.id}/attempts/${attempt?.id}`,
          },
          filters: buildActivityDateFilter(dateRange),
        });

        if (response.status === HTTP_STATUSES.OK) {
          setAttemptActivities(
            response.data.sort(
              (a: { createdOn: string }, b: { createdOn: string }) =>
                new Date(b.createdOn).getTime() -
                new Date(a.createdOn).getTime()
            )
          );
        }
      });
    },
    [attempt]
  );

  return {
    attemptActivities,
    getAttemptActivities,
  };
};
